import React, { FC } from 'react';
import { Box, Flex, Switch, Text } from '@televet/kibble-ui';
import { FeatureFlagName } from 'shared/enums';
import useOttoLabsClinicSettings from '../hooks/useOttoLabsClinicSettings';

type OttoLabsClinicSettingProps = {
  flag: FeatureFlagName;
};

const OttoLabsClinicSetting: FC<OttoLabsClinicSettingProps> = ({ flag }) => {
  const { setting, isEnabled, toggleFeatureFlag } = useOttoLabsClinicSettings(flag);

  if (!setting) {
    return <></>;
  }

  return (
    <Flex>
      <Flex width={'300px'} alignItems="center">
        <Switch isChecked={isEnabled} onChange={toggleFeatureFlag} label={setting.label} isFieldInline />
      </Flex>
      <Box flex="1">
        <Text>{setting.description}</Text>
      </Box>
    </Flex>
  );
};

export default OttoLabsClinicSetting;
